import { formatNumber } from "../../../helpers/formatter";

function configs(labels, datasets, numberType = null) {
   return {
      data: {
         labels,
         datasets: [...datasets],
      },
      options: {
         responsive: true,
         maintainAspectRatio: false,
         // Breathing room inside the canvas — without it the line + point
         // markers render flush against the canvas edge and the wave looks
         // chopped off at the tile border (responsiveness QA).
         layout: {
            padding: { top: 6, right: 7, bottom: 4, left: 4 },
         },
         plugins: {
            legend: {
               display: false,
            },
            tooltip: {
               callbacks: {
                  label: (yPoint) => " " + formatNumber(Math.abs(yPoint.raw), numberType),
               }
            }
         },
         interaction: {
            intersect: false,
            mode: "index",
         },
         scales: {
            y: {
               grid: {
                  drawBorder: false,
                  display: false,
                  drawOnChartArea: false,
                  drawTicks: false,
               },
               ticks: {
                  display: false,
               },
            },
            x: {
               grid: {
                  drawBorder: false,
                  display: false,
                  drawOnChartArea: false,
                  drawTicks: false,
               },
               ticks: {
                  display: false,
               },
            },
         },
      },
   };
}

export default configs;
